/* eslint-disable react/no-array-index-key */
import React from 'react';
import { css } from '@emotion/react';
import {
  quarterSpacing,
  halfSpacing,
  standardSpacing,
} from 'styles/global_defaults/scaffolding';
import { gray6 } from 'styles/global_defaults/colors';
import { commonStyles } from 'athena/components/mentoring-program/participants/participant-row/styles';

type Props = {
  className?: string;
};

const LoadingRow = (props: Props) => {
  const { className } = props;

  const styles = css`
    ${commonStyles};
    min-height: 48px;
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 2fr 1fr 50px 56px;
    align-items: center;
    gap: ${halfSpacing}px;
    padding-left: 0 !important;
    padding-right: 0 !important;
    .col {
      display: flex;
      align-items: center;
    }
    .col:first-child {
      padding-left: ${standardSpacing}px;
    }
    .name-placeholder {
      background-color: ${gray6};
      height: ${halfSpacing}px;
      border-radius: ${quarterSpacing}px;
    }
    .name-placeholder.message-type,
    .name-placeholder.subject,
    .name-placeholder.to {
      width: 50%;
      min-width: 32px;
      max-width: 100%;
    }
    .name-placeholder.status {
      width: 50px;
      height: ${standardSpacing}px;
      border-radius: ${standardSpacing}px;
    }
  `;

  return (
    <div css={styles} className={className}>
      <div className='col'>
        <div className='name-placeholder message-type' />
      </div>
      <div className='col'>
        <div className='name-placeholder subject' />
      </div>
      <div className='col'>
        <div className='name-placeholder to' />
      </div>
      <div className='col'>
        <div className='name-placeholder status' />
      </div>
    </div>
  );
};

export default LoadingRow;
